// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { theme } from '../../assets/styles/theme';
import media from 'assets/styles/query';
import styled, { css } from 'styled-components';

interface Props {
  open?: boolean;
  color: any;
}

export const Container = styled.header<Props>`
  width: 100%;
  height: ${theme.headerHeight};
  background-color: rgba(5, 12, 19, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  border-bottom: 1px solid #202020;
  padding: 0px 20px;
  z-index: 999;
  transition: 0.3s ease-in-out;

  ${(props) =>
    !props.open &&
    css`
      backdrop-filter: blur(20px);
    `}

  ${(props) =>
    props.color === 'gray' &&
    css`
      background-color: rgba(0, 0, 0, 0.7);
    `}

  ${(props) =>
    props.color === 'purple' &&
    css`
      background-color: rgba(28, 0, 24, 0.5);
      border-color: rgba(65, 1, 77, 1);
    `}

  ${(props) =>
    props.color === 'blue' &&
    css`
      background-color: rgba(0, 14, 28, 0.5);
      border-color: rgba(1, 46, 77, 1);
    `}

  ${(props) =>
    props.color === 'yellow' &&
    css`
      background-color: rgba(13, 13, 13, 0.9);
      border-color: rgba(252, 222, 134, 0.15);
    `}

  ${(props) =>
    props.color === 'white' &&
    css`
      background-color: rgba(0, 0, 0, 0.5);
      border-color: rgba(0, 0, 0, 0.15);
    `}

  ${(props) =>
    props.color === 'transparent' &&
    css`
      background-color: rgba(255, 255, 255, 0.05);
      border-color: rgba(0, 0, 0, 0.15);
    `}

  @media (max-width: 768px) {
    ${(props) =>
      props.color === 'white' &&
      css`
        background-color: rgba(255, 255, 255, 1);
        border-color: rgba(0, 0, 0, 0.15);
      `}
  }
`;

export const Overlay = styled.div<Props>`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100dvh;
  background-color: rgba(13, 13, 14, 0.5);
  display: flex;
  backdrop-filter: blur(25px);
  opacity: 0;
  visibility: hidden;
  transition: all 400ms ease;
  display: flex;
  z-index: 999;

  .overlay-menu {
    transition: all 400ms ease;
    opacity: 0;
    visibility: hidden;
    padding: 125px 50px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    button {
      transition: all 400ms ease;
      background: transparent;
      border: none;
      text-align: left;
      color: #c6c2f7;
      font-size: 40px;
      font-family: 'SF Pro Display';
      font-weight: 700;
      opacity: 0;
      transform: translateX(-10px);

      &:nth-of-type(1) {
        transition-delay: 90ms;
      }

      &:nth-of-type(2) {
        transition-delay: 150ms;
      }

      &:nth-of-type(3) {
        transition-delay: 190ms;
      }

      &:nth-of-type(4) {
        transition-delay: 250ms;
      }

      &:nth-of-type(5) {
        transition-delay: 290ms;
      }

      &:nth-of-type(6) {
        transition-delay: 350ms;
      }
    }

    ${(props) =>
      props.color === 'gray' &&
      css`
        button {
          color: rgba(166, 166, 166, 1);
        }
      `}

    ${(props) =>
      props.color === 'purple' &&
      css`
        button {
          color: rgba(198, 116, 201, 1);
        }
      `}

    ${(props) =>
      props.color === 'blue' &&
      css`
        button {
          color: rgba(1, 183, 249, 1);
        }
      `}

    ${(props) =>
      props.color === 'yellow' &&
      css`
        button {
          color: rgba(252, 222, 134, 1);
        }
      `}

    ${(props) =>
      props.color === 'white' &&
      css`
        button {
          color: rgba(0, 0, 0, 1);
        }
      `}

    ${(props) =>
      props.color === 'transparent' &&
      css`
        button {
          color: rgba(255, 255, 255, 1);
        }
      `}
  }

  ${(props) =>
    props.open &&
    css`
      opacity: 1;
      visibility: visible;

      .overlay-menu {
        opacity: 1;
        visibility: visible;

        button {
          opacity: 1;
          visibility: visible;
          transform: translateX(0px);
        }
      }
    `}

  ${(props) =>
    props.color === 'gray' &&
    css`
      background-color: rgba(0, 0, 0, 0.7);
    `}

  ${(props) =>
    props.color === 'purple' &&
    css`
      background-color: rgba(28, 0, 24, 0.5);
    `}

  ${(props) =>
    props.color === 'blue' &&
    css`
      background-color: rgba(0, 14, 28, 0.5);
    `}

  ${(props) =>
    props.color === 'yellow' &&
    css`
      background-color: rgba(13, 13, 13, 0.9);
    `}

  ${(props) =>
    (props.color === 'white' || props.color === 'transparent') &&
    css`
      background-color: rgba(255, 255, 255, 0.2);
    `}
`;

export const Hamburguer = styled.button<Props>`
  display: block;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c6c2f7;
  user-select: none;
  background: transparent;
  border: none;
  height: ${theme.headerHeight};
  z-index: 1000;

  .menu-icon-container {
    width: 28px;
    height: 44px;
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 200;

    .menu-icon {
      position: relative;
      width: 100%;

      .line-1,
      .line-2 {
        position: absolute;
        height: 3px;
        width: 100%;
        border-radius: 2px;
        background: #c6c2f7;
        transition-property: transform, top;
        transition-delay: 0ms, 160ms;
        transition-duration: 200ms;
      }

      .line-1 {
        top: -5px;
      }

      .line-2 {
        top: 5px;
      }
    }

    ${(props) =>
      props.open &&
      css`
        .menu-icon .line-1 {
          top: 0;
          transform: rotateZ(45deg);
          transition-property: top, transform;
          transition-delay: 0ms, 160ms;
          transition-duration: 200ms;
        }

        .menu-icon .line-2 {
          top: 0;
          transform: rotateZ(-45deg);
          transition-property: top, transform;
          transition-delay: 0ms, 160ms;
          transition-duration: 200ms;
        }
      `}
  }

  ${(props) =>
    props.color === 'gray' &&
    css`
      color: rgba(166, 166, 166, 1);

      .menu-icon-container {
        .menu-icon {
          .line-1,
          .line-2 {
            background: rgba(166, 166, 166, 1);
          }
        }
      }
    `}

  ${(props) =>
    props.color === 'purple' &&
    css`
      color: rgba(198, 116, 201, 1);

      .menu-icon-container {
        .menu-icon {
          .line-1,
          .line-2 {
            background: rgba(198, 116, 201, 1);
          }
        }
      }
    `}

  ${(props) =>
    props.color === 'blue' &&
    css`
      color: rgba(1, 183, 249, 1);

      .menu-icon-container {
        .menu-icon {
          .line-1,
          .line-2 {
            background: rgba(1, 183, 249, 1);
          }
        }
      }
    `}

  ${(props) =>
    props.color === 'yellow' &&
    css`
      color: rgba(252, 222, 134, 1);

      .menu-icon-container {
        .menu-icon {
          .line-1,
          .line-2 {
            background: rgba(252, 222, 134, 1);
          }
        }
      }
    `}

  ${(props) =>
    props.color === 'white' &&
    css`
      color: rgba(0, 0, 0, 1);

      .menu-icon-container {
        .menu-icon {
          .line-1,
          .line-2 {
            background: rgba(0, 0, 0, 1);
          }
        }
      }
    `}

  ${(props) =>
    props.color === 'transparent' &&
    css`
      color: rgba(255, 255, 255, 1);

      .menu-icon-container {
        .menu-icon {
          .line-1,
          .line-2 {
            background: rgba(255, 255, 255, 1);
          }
        }
      }
    `}
`;

export const Navigation = styled.nav<Props>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${theme.headerHeight};

  div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: center;

    color: rgb(255 255 255 / 80%);
    font-family: SF Pro Display;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 37.626px;

    &.black {
      color: #000;
    }
  }

  ${media.greaterThan('small')`
    justify-content: center;

    > div {

      &:hover {
        cursor: pointer;
      }
    }

    button {
      position: relative;
      margin: 0 10px;
      border: none;
      background: transparent;
      color: #c6c2f7;
      outline: none;
      font-weight: 300;
      font-size: 14px;
      font-family: 'SF Pro Text';
      letter-spacing: 1px;
      opacity: 0.5;
      transition: 0.3s ease-in-out;


      &:hover {
        opacity: 1;
        cursor: pointer;

        &::after {
          right: 0;
          left: 0;
          width: 100%;
        }
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: -5px;
        width: 0;
        height: 2px;
        background: #882ef2;
        transition: width 0.6s cubic-bezier(0.25, 1, 0.5, 1);
      }

      &:active {
        transform: scale(0.9);
      }

      svg {
        margin: 0 -22px;
      }
    }

    svg {
      width: 30px;
      height: 45px;
      margin: 4px 8px 0;
      transition: 0.3s ease-in-out;
    }

  `};

  ${(props) =>
    props.color === 'gray' &&
    css`
      button {
        color: rgba(166, 166, 166, 1);

        &::after {
          background: rgba(166, 166, 166, 1);
        }
      }

      svg {
        color: rgba(166, 166, 166, 1);
      }
    `}

  ${(props) =>
    props.color === 'purple' &&
    css`
      button {
        color: rgba(198, 116, 201, 1);

        &::after {
          background: rgba(198, 116, 201, 1);
        }
      }

      svg {
        color: rgba(198, 116, 201, 1);
      }
    `}

  ${(props) =>
    props.color === 'blue' &&
    css`
      button {
        color: rgba(1, 183, 249, 1);

        &::after {
          background: rgba(1, 183, 249, 1);
        }
      }

      svg {
        color: rgba(1, 183, 249, 1);
      }
    `}

  ${(props) =>
    props.color === 'yellow' &&
    css`
      button {
        color: rgba(252, 222, 134, 1);

        &::after {
          background: rgba(252, 222, 134, 1);
        }
      }

      svg {
        color: rgba(252, 222, 134, 1);
      }
    `}

  ${(props) =>
    (props.color === 'white' || props.color === 'transparent') &&
    css`
      button {
        color: rgba(255, 255, 255, 1);

        &::after {
          background: rgba(255, 255, 255, 1);
        }
      }

      svg {
        color: rgba(255, 255, 255, 1);
      }
    `}

  @media (max-width: 768px) {
    ${(props) =>
      props.color === 'white' &&
      css`
        button {
          color: rgba(0, 0, 0, 1);

          &::after {
            background: rgba(0, 0, 0, 1);
          }
        }

        svg {
          color: rgba(0, 0, 0, 1);
        }
      `}
  }
`;
